import React, { useState } from 'react';
import Footer from './Footer';
import Home from './Home';

function App() {

	return (
		<div>
		<div className="App">
			
			<div className="content">
				<Home />
			</div>
			<Footer/>
		</div>
	  </div>
  	);
}
	
export default App;
